import { useContext } from 'react';
import AuthContext from '../../store/auth-context';
import { AccessibilityContext } from '../../store/accesibility-context';

import './DashboardGreet.scss';

const DashboardGreet = () => {
	const authCtx = useContext(AuthContext);
	const accessibilityCtx = useContext(AccessibilityContext);

	return (
		<div className={`${accessibilityCtx.font_Size ? 'dashboard-greet-container-font':'dashboard-greet-container'}`}>
			
			<div className='greet-title'>
				<h1>
					Welcome, {authCtx.userData.firstname} (
					{authCtx.userData.role}){' '}
				</h1>
				<p className='greet-subtitle'>
					Empower your journey with Ginseng. Let's get
					advanced care to patients together by expediting
					this step!
				</p>
			</div>
		</div>
	);
};

export default DashboardGreet;
